import React from 'react';
import { ListPost } from "../../../components/Web";
import { Container } from "semantic-ui-react";

export function Home() {
  return (
    <Container>
      <ListPost />
    </Container>
  )
}
